"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports.default = void 0;

require("core-js/modules/es6.object.freeze");

var _typeof2 = _interopRequireDefault(require("@babel/runtime/helpers/typeof"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

/**
 * Data about a number
 * @param {object} options - See below
 * @param {number} options.number - The number to display
 * 
 * @property {number} number
 */
var NumberData = function NumberData(options) {
  (0, _classCallCheck2.default)(this, NumberData);

  if (!options || (0, _typeof2.default)(options) !== 'object') {
    throw new TypeError("options must be an object. Value Provided: ".concat(options));
  }

  if (typeof options.number !== 'number') {
    throw new TypeError("options.number must be a number. Provided value: ".concat(options.number));
  }

  this.number = options.number;
  Object.freeze(this);
};

exports.default = NumberData;